// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';

type SwitchProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void; // eslint-disable-line no-unused-vars
  leftLabel?: string;
  rightLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
};

const Switch: FC<SwitchProps> = ({
  id,
  checked,
  onChange,
  leftLabel,
  rightLabel,
  disabled = false,
  size = 'sm',
  className = '',
  labelClassName = '',
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div className="d-flex align-items-center">
      {leftLabel && (
        <span
          className={`fs-12px pt-0 mr-5 ${
            checked ? '' : 'fw-bold'
          } ${labelClassName}`}
        >
          {leftLabel}
        </span>
      )}
      <div
        className={`custom-control custom-switch custom-control-${size} pl-0 ${className}`}
      >
        <input
          type="checkbox"
          className="custom-control-input"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />

        {rightLabel && (
          <label
            className={`custom-control-label ${
              checked ? 'fw-bold' : ''
            } ${labelClassName}`}
            htmlFor={id}
          >
            {rightLabel}
          </label>
        )}
      </div>
    </div>
  );
};

export default Switch;
